import { render, staticRenderFns } from "./KEditPhoto.vue?vue&type=template&id=c0b40a7c&scoped=true"
import script from "./KEditPhoto.vue?vue&type=script&lang=js"
export * from "./KEditPhoto.vue?vue&type=script&lang=js"
import style0 from "./KEditPhoto.vue?vue&type=style&index=0&id=c0b40a7c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b40a7c",
  null
  
)

export default component.exports